module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ID - Indonesia.c64956a6.svg";